import { MomentObj } from "@veneer/core";
import { maxEndDate } from "./maxEndDateByMonth";
import moment from 'moment';

export const rangeBeforeAndAfterDates = (
  day: MomentObj,
  startDate: moment.Moment | undefined
) => {
  if (!startDate) return false;

  const isBeforeStart = day.isBefore(startDate, "day");

  const today = moment();
  const maxEnd = moment.min(maxEndDate(startDate), today);

  const isAfterMaxEnd = day.isAfter(maxEnd, "day");

  return isBeforeStart || isAfterMaxEnd;
};
